<template>
    <div class="row">
        <template>
            <div class="col-12" style="text-align: initial;">
                <div class="alert alert-info" role="alert">
                    Comentario : {{ comment }}
                </div>
                <div class="form-group" style="text-align: left">
                    <small style="color: #595959;">Respuesta *</small>
                    <div class="input-group mb-3">
                        <input :class="{ 'is-danger': errors.respuesta }" type="text" v-model="respuesta"
                            class="form-control" id="name" rows="3" />
                    </div>
                    <span v-if="errors.name"
                        class="text-danger float-left small error-danger mb-2">{{ errors.name }}</span>
                </div>
            </div>

            <div class="col-12 col-md-12 col-lg-4 col-xl-4 col-sm-12 mt-4 mb-3">
                <button @click="cancel()" style="background-color: #E6E6E6" class="btn btn-block">
                    Cancelar
                </button>
            </div>

            <div class="col-12 col-md-12 col-lg-4 col-xl-4 col-sm-12 mt-4 mb-3">
                <button @click="buy()" class="btn btn-danger btn-block">
                    Responder comentario
                </button>
            </div>
        </template>
    </div>
</template>

<script>

import axios from 'axios'
export default {
    props: { 
        comment: String,
        commentId: Number
    },
    data() {
        return {
            confirmation: false,
            respuesta:null,
            amount: 0,
            dataUser: [],
            data: [],
            allData: [],
            listDocuments: [],
            listStates: [],
            listCities: [],
            showCities: false,
            prevImgSoat: "",
            prevImgTarjeta: "",
            form: {
                flagSoat: false,
                // documentType: null,
                // numberDocument: "",
                // name: "",
                // lastName: "",
                address: "",
                additionalAddress: "",
                // phone: "",
                // email: "",
                state: null,
                cityId: null,
                cityName: "",
                statesName: "",
                typeDocumentN: "",
                imgSoat: [],
                imgTarjeta: [],
                imgs: [],
            },
            errors: {
                additionalAddress: false,
                numberDocument: false,
                documentType: false,
                name: false,
                lastName: false,
                address: false,
                phone: false,
                state: false,
                cityId: false,
                email: false,
                errorsSoat: false,
                errorsSoat2: false,
                errorsTarjeta: false,
                errorsTarjeta2: false,
            }
        };
    },
    methods: {
        getDataUser() {
            var app = this;
            axios
            .get("api/showUser")
            .then(function(res) {
                app.dataUser = res.data.User;
                // console.log('app.dataUser: ', JSON.stringify(app.dataUser));
            })
            .catch(function(error) {
                console.log(error);
            });
        },
        getInfoUser(){
            this.data = {
                documentType: this.dataUser.document_type_id,
                numberDocument: this.dataUser.document_number,
                name: this.dataUser.name,
                lastName: this.dataUser.last_name,
                phone: this.dataUser.phone,
                email: this.dataUser.email,
            };
            Object.assign(
                this.form,
                this.data
            );
            // console.log('this.form: ', JSON.stringify(this.form));
        },
        clearForm() {
            var app = this;
            app.form = {
                documentType: null,
                numberDocument: "",
                name: "",
                lastName: "",
                address: "",
                additionalAddress: "",
                phone: "",
                email: "",
                state: null,
                cityId: null,
                cityName: "",
                statesName: "",
                typeDocumentN: "",
                imgSoat: [],
                imgTarjeta: [],
                imgs: [],
            }
            setTimeout(function () {
                app.errors = {
                    numberDocument: false,
                    documentType: false,
                    name: false,
                    lastName: false,
                    address: false,
                    phone: false,
                    state: false,
                    cityId: false,
                    email: false,
                }
                if(this.flagSoat == true){
                    app.errorsSoat = false,
                    app.errorsSoat2 = false,
                    app.errorsTarjeta = false,
                    app.errorsTarjeta2 = false
                }
            }, 10);
        },
        buy() {
            this.confirmation = false;
            this.$emit("buy", this.respuesta);
            this.clearForm();
        },
        cancel() {
            this.confirmation = false;
            this.clearForm();
            this.$emit("cancel", true);
        },
        corregir() {
            this.confirmation = false;
            this.form.typeDocumentN = "";
            this.form.statesName = "";
            this.form.cityName = "";
        },
        confirmation1() {
            if (this.validateForm()) {
                this.getInfoUser();
                for (let i = 0; i < this.listDocuments.length; i++) {
                    if (this.listDocuments[i].id == this.dataUser.document_type_id) {
                        this.form.typeDocumentN = this.listDocuments[i].name;
                    }
                }
                for (let i = 0; i < this.listStates.length; i++) {
                    if (this.listStates[i].id == this.form.state) {
                        this.form.statesName = this.listStates[i].name;
                    }
                }
                for (let i = 0; i < this.listCities.length; i++) {
                    if (this.listCities[i].id == this.form.cityId) {
                        this.form.cityName = this.listCities[i].name;
                    }
                }
                this.confirmation = true;
            }
        },
        getCities(stateId) {
            var app = this;
            var data = {
                stateId: stateId
            };
            axios
                .post("api/showCity", data)
                .then(function (res) {
                    app.showCities = false;
                    app.listCities = res.data.cities;
                })
                .catch(function () {
                    // console.log(err);
                });
        },
        obtenerImgSoat(event){
            var fileSize = null;
            var extension = null;
            fileSize = event.target.files[0].size;
            extension = event.target.files[0].name.split(".");
            if (fileSize > 1000000) {
                this.errors.errorsSoat = "El archivo no debe superar 1MB.";
                return false;
            }
            if (
            extension[1] != "jpg" &&
            extension[1] != "jpeg" &&
            extension[1] != "png"
            ) {
                this.errors.errorsSoat2 = "La extensión es inválida.";
                return false;
            } else {
                this.errors.errorsSoat = false;
                this.errors.errorsSoat2 = false;

                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (e) => {
                    this.prevImgSoat = e.target.result;
                }
                this.form.imgSoat.push({ file: event.target.files[0], index: 0 });
                // console.log("img_soat", this.form.imgSoat);
            }
        },
        obtenerImgTarjeta(event){
            var fileSize = null;
            var extension = null;
            fileSize = event.target.files[0].size;
            extension = event.target.files[0].name.split(".");
            if (fileSize > 1000000) {
                this.errors.errorsTarjeta = "El archivo no debe superar 1MB.";
                return false;
            }
            if (
            extension[1] != "jpg" &&
            extension[1] != "jpeg" &&
            extension[1] != "png"
            ) {
                this.errors.errorsTarjeta2 = "La extensión es inválida.";
                return false;
            } else {
                this.errors.errorsTarjeta = false;
                this.errors.errorsTarjeta2 = false;

                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (e) => {
                    this.prevImgTarjeta = e.target.result;
                }
                this.form.imgTarjeta.push({ file: event.target.files[0], index: 0 });
                // console.log("img_tarjeta", this.form.imgTarjeta);
            }
        },
        validateForm() {
            if (!this.form.state) {
                this.errors.state = "El departamento es requerido.";
            }
            if (!this.form.cityId) {
                this.errors.cityId = "La ciudad es requerida.";
            }
            if (!this.form.address) {
                this.errors.address = "La dirección es requerida.";
            }
            if (!this.form.additionalAddress) {
                this.errors.additionalAddress = "Las especificaciones de la vivienda es requerida.";
            }
            if(this.flagSoat == true){
                if (this.form.imgSoat == "") {
                    this.errors.errorsSoat = "La imágen del soat vencido es requerida";
                }
                if (this.form.imgTarjeta == "") {
                    this.errors.errorsTarjeta = "La imágen de la tarjeta de propiedad es requerida";
                }
            }
            if (
                !this.errors.additionalAddress &&
                !this.errors.address &&
                !this.errors.state &&
                !this.errors.cityId &&
                !this.errors.documentType &&
                !this.errors.numberDocument &&
                !this.errors.name &&
                !this.errors.lastName &&
                !this.errors.phone &&
                !this.errors.email &&
                !this.errors.soat &&
                !this.errors.tarjeta &&
                !this.errors.errorsSoat &&
                !this.errors.errorsTarjeta &&
                !this.validEmail(this.errors.email)
            ) {
                return true;
            }
            return false;
        },
        validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    },
    computed: {
        // imgagenSoat(){
        //     return this.prevImgSoat;
        // },
        // imgagenTarjeta(){
        //     return this.prevImgTarjeta;
        // },
    },
    mounted() {
        // console.log("Entro a mounted()")
        console.log(`data ${this.comment} - ${this.commentId}`);
        this.confirmation = true;
    },
    watch: {
        "form.cityId": function (n) {
            if (n == 0) {
                this.errors.cityId = "La ciudad es requerida.";
            } else {
                this.errors.cityId = false;
            }
        },
        "form.state": function (n) {
            if (n != null) {
                this.getCities(n);
            }
            if (n == 0) {
                this.errors.state = "El departamento es requerido.";
            } else {
                this.errors.state = false;
            }
        },
        "form.documentType": function (n) {
            if (!n) {
                this.errors.documentType = "El tipo de documento es requerido.";
            } else {
                this.errors.documentType = false;
            }
        },
        "form.numberDocument": function (n) {
            if (!n) {
                this.errors.numberDocument = "El número de documento es requerido.";
            } else {
                this.errors.numberDocument = false;
            }
        },
        "form.name": function (n) {
            if (!n) {
                this.errors.name = "El nombre es requerido.";
            } else {
                this.errors.name = false;
            }
        },
        "form.lastName": function (n) {
            if (!n) {
                this.errors.lastName = "El apellido es requerido.";
            } else {
                this.errors.lastName = false;
            }
        },
        "form.address": function (n) {
            if (!n) {
                this.errors.address = "La dirección es requerida.";
            } else {
                this.errors.address = false;
            }
        },
        "form.phone": function (n) {
            if (!n) {
                this.errors.phone = "El teléfono es requerido.";
            } else {
                this.errors.phone = false;
            }
        },
        "form.additionalAddress": function (n) {
            if (!n) {
                this.errors.additionalAddress = "Las especificaciones de la vivienda es requerida.";
            } else {
                this.errors.additionalAddress = false;
            }
        },
        "form.email": function (n) {
            if (!n) {
                this.errors.email = "El email es requerido.";
            } else if (!this.validEmail(n)) {
                this.errors.email = "El email es inválido.";
            } else {
                this.errors.email = false;
            }
        },
    }
};
</script>

<style scoped>
.text-confirmation {
    color: #595959;
}
.btn-shop {
    border-radius: 0px 0px 25px 25px;
}
.col-total {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
}
.card-total {
    width: 80%;
    border-radius: 25px;
}
.icon-close-card:hover {
    color: black !important;
}
.td-card {
    padding: 0px !important;
}
.table-h {
    border-radius: 25px;
}
.table-light tbody+tbody,
.table-light td,
.table-light th,
.table-light thead th {
    border-color: #d8d8dc;
}
.prod-card {
    width: 100px;
}
.content-card {
    padding-top: 0.5%;
    padding-bottom: 3%;
    background-color: #eaeaea;
    background-size: cover;
    background-image: url("../../../../assets/shop.png");
    background-position: center center;
    background-attachment: fixed;
}
.subtitle-card {
    color: #dc3545;
    font-size: 23px;
    font-family: "GothamBoldItalic", sans-serif;
}
#tarjeta, #soat{
    padding: 3px;
}

@font-face {
    font-family: "GothamBoldItalic", sans-serif;
    src: url("../../../../assets/font/GothamBoldItalic.ttf");
    font-display: swap;
}

/* TABLET */
@media (max-width: 1023px) {
    .card-total {
        width: 80%;
    }
    .col-total {
        padding: 10px;
        display: flex;
        justify-content: flex-end;
    }
}

/* MOBILE */
@media (max-width: 767px) {
    .card-total {
        width: 80%;
    }
    .col-total {
        padding: 10px;
        display: flex;
        justify-content: center;
    }
}
</style>